<div class="encadre-conseil">
  <div class="encadre-icon">
    <img
      class="info-icon"
      src="{{ 'assets/images/information-circle.svg' | cheminAbsoluStatique }}"
      alt="Information"
    />
  </div>
  <p class="encadre-main-text">
    <span [innerHTML]="textConseil | translate"></span>
    <a
      class="link"
      [href]="safeUrl"
      target="_blank"
      [innerText]="linkTitle | translate"
      [attr.aria-label]="linkLabelSR | translate"
    ></a
    >.
  </p>
</div>
